import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  signal,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[overflowTooltip]',
  standalone: true,
  hostDirectives: [MatTooltip],
})
export class OverflowTooltipDirective {
  private matTooltip = inject(MatTooltip);
  private elementRef = inject(ElementRef<HTMLElement>);
  private showTooltip = signal(false);

  useOffsetWidth = input<boolean>(false);
  useClampMode = input<boolean>(false);

  @HostListener('mouseenter', ['$event.target'])
  handleMouseEnter(target: HTMLElement) {
    const {
      scrollWidth,
      clientWidth,
      offsetWidth,
      scrollHeight,
      clientHeight,
    } = target;
    if (this.useClampMode()) {
      this.showTooltip.set(scrollHeight > clientHeight);
    } else {
      if (this.useOffsetWidth()) {
        this.showTooltip.set(scrollWidth > offsetWidth);
      } else {
        this.showTooltip.set(scrollWidth > clientWidth);
      }
    }
    if (this.showTooltip()) {
      this.matTooltip.message = this.elementRef.nativeElement.textContent;
      this.matTooltip.show();
    } else {
      this.matTooltip.message = '';
    }
  }

  @HostListener('mouseleave')
  handleMouseLeave() {
    this.matTooltip.hide();
  }
}
